import { render, staticRenderFns } from "./feedback_list.vue?vue&type=template&id=b3004b2a&scoped=true&"
import script from "./feedback_list.vue?vue&type=script&lang=js&"
export * from "./feedback_list.vue?vue&type=script&lang=js&"
import style0 from "./feedback_list.vue?vue&type=style&index=0&id=b3004b2a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3004b2a",
  null
  
)

export default component.exports